import React from "react";
import Backdrop from "../Backdrop/Backdrop";
import styles from "./Buy.module.scss";

const Buy = ({ setIsModalOpen, setIsModalOpen2 }) => {
  return (
    <div className={styles.mainContainer}>
      <Backdrop />
      <div className={styles.container}>
        <span onClick={() => setIsModalOpen(false)}>&times;</span>
        <div className={styles.content}>
          <h4>Buy now</h4>

          <h6>Price</h6>
          <ul>
            <li>
              <div className={styles.left}>
                <p>Price in USD</p>
              </div>
              <div className={styles.right}>
                <p>$45.98</p>
              </div>
            </li>

            <li>
              <div className={styles.left}>
                <p>Price in SOL</p>
              </div>
              <div className={styles.right}>
                <p>0.56SOL</p>
              </div>
            </li>

            <li>
              <div className={styles.left}>
                <p>Network fees</p>
              </div>
              <div className={styles.right}>
                <p>0.006SOL</p>
              </div>
            </li>

            <li>
              <div className={styles.left}>
                <p>Total</p>
              </div>
              <div className={styles.right}>
                <p>0.61SOL</p>
              </div>
            </li>
          </ul>

          <button onClick={() => setIsModalOpen2(true)}>Buy Now</button>
          <button>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default Buy;
